var _style, _g, _g2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const Svg403 = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "524.9px",
    height: "216.5px",
    viewBox: "0 0 524.9 216.5",
    style: {
      enableBackground: "new 0 0 524.9 216.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E0E0E0;}\r\n\t.st1{fill:#EBEBEB;}\r\n\t.st2{fill:none;stroke:#707070;stroke-width:3;}\r\n\t.st3{fill:#12112B;}\r\n\t.st4{fill:#455A64;}\r\n\t.st5{fill:#49409A;}\r\n\t.st6{fill:#E8505B;}\r\n\t.st7{fill:#2F2A64;}\r\n\t.st8{fill:#263238;}\r\n\t.st9{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    transform: "translate(654.343 159.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    transform: "translate(522.513 186.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    className: "st0",
    d: "M-652.1-182.5c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.6,0-1.4,0-2.4c0-2.1,0-5.2-0.1-9 l0.1,0.1l-45.6,0.1c0.1-0.1-0.2,0.2,0.2-0.2v3.1c0,1,0,2.1,0,3.1c0,2,0,4.1,0,6l-0.2-0.2l32.5,0.1l9.6,0.1h2.6h0.7 C-652.2-182.6-652.2-182.6-652.1-182.5c-0.1,0-0.1,0-0.2,0h-0.7h-2.5l-9.5,0.1l-32.6,0.1h-0.2v-0.2c0-2,0-4,0-6 c0-1,0-2.1,0-3.1v-3.1c0.4-0.4,0.1-0.1,0.2-0.2l45.6,0.1h0.1v0.1c0,3.9-0.1,7-0.1,9.1c0,1,0,1.8,0,2.4 C-652-182.9-652-182.7-652.1-182.5C-652.1-182.7-652.1-182.6-652.1-182.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    transform: "translate(303.772 35.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1761",
    x: -697.9,
    y: -195,
    className: "st1",
    width: 45.6,
    height: 12.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    transform: "translate(18.869 12.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    className: "st0",
    d: "M-652.1-182.5c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.6,0-1.4,0-2.4c0-2.1,0-5.2-0.1-9 l0.1,0.1l-45.6,0.1c0.1-0.1-0.2,0.2,0.2-0.2v3.1c0,1,0,2.1,0,3.1c0,2,0,4.1,0,6l-0.2-0.2l32.5,0.1l9.6,0.1h2.6h0.7 C-652.2-182.6-652.2-182.6-652.1-182.5c-0.1,0-0.1,0-0.2,0h-0.7h-2.5l-9.5,0.1l-32.6,0.1h-0.2v-0.2c0-2,0-4,0-6 c0-1,0-2.1,0-3.1v-3.1c0.4-0.4,0.1-0.1,0.2-0.2l45.6,0.1h0.1v0.1c0,3.9-0.1,7-0.1,9.1c0,1,0,1.8,0,2.4 C-652-182.9-652-182.7-652.1-182.5C-652.1-182.7-652.1-182.6-652.1-182.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    transform: "translate(75.015 207.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    className: "st0",
    d: "M-652.1-182.5c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.6,0-1.4,0-2.4c0-2.1,0-5.2-0.1-9 l0.1,0.1l-45.6,0.1c0.1-0.1-0.2,0.2,0.2-0.2v3.1c0,1,0,2.1,0,3.1c0,2.1,0,4.1,0,6l-0.2-0.2l32.5,0.1l9.6,0.1h2.6h0.7 C-652.2-182.6-652.2-182.6-652.1-182.5c-0.1,0-0.1,0-0.2,0h-0.7h-2.5l-9.5,0.1l-32.6,0.1h-0.2v-0.2c0-2,0-4,0-6 c0-1,0-2.1,0-3.1v-3.1c0.4-0.4,0.1-0.1,0.2-0.2l45.6,0.1h0.1v0.1c0,3.9-0.1,7-0.1,9.1c0,1,0,1.8,0,2.4 C-652-182.9-652-182.7-652.1-182.5C-652.1-182.7-652.1-182.6-652.1-182.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    transform: "translate(102.883 219.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    className: "st0",
    d: "M-674.9-182.5c0-0.1,0-0.2,0-0.2c0-0.2,0-0.4,0-0.7c0-0.6,0-1.4,0-2.5c0-2.2,0-5.2-0.1-8.9 l0.2,0.2h-22.8c-0.2,0.2,0.3-0.3,0.2-0.2v1.6c0,0.5,0,1.1,0,1.6c0,1.1,0,2.1,0,3.1c0,2.1,0,4,0,5.9l-0.2-0.2l16.3,0.1l4.7,0.1 h1.3C-675.2-182.5-675-182.5-674.9-182.5c-0.1,0-0.3,0-0.4,0h-1.2l-4.7,0.1l-16.5,0.1h-0.2v-0.2c0-1.9,0-3.9,0-5.9 c0-1,0-2.1,0-3.1c0-0.5,0-1.1,0-1.6v-1.6c0,0,0.4-0.4,0.2-0.2h22.8h0.2v0.2c0,3.8-0.1,6.8-0.1,9c0,1,0,1.8,0,2.4 c0,0.3,0,0.5,0,0.6C-674.9-182.7-674.9-182.6-674.9-182.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    transform: "translate(505.701 57.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    className: "st0",
    d: "M-652.1-182.5c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.6,0-1.4,0-2.4c0-2.1,0-5.2-0.1-9 l0.1,0.1l-45.6,0.1c0.1-0.1-0.2,0.2,0.2-0.2v3.1c0,1,0,2.1,0,3.1c0,2,0,4.1,0,6l-0.2-0.2l32.5,0.1l9.6,0.1h2.6h0.7 C-652.2-182.6-652.2-182.6-652.1-182.5c-0.1,0-0.1,0-0.2,0h-0.7h-2.5l-9.5,0.1l-32.6,0.1h-0.2v-0.2c0-2,0-4,0-6 c0-1,0-2.1,0-3.1v-3.1c0.4-0.4,0.1-0.1,0.2-0.2l45.6,0.1h0.1v0.1c0,3.9-0.1,7-0.1,9.1c0,1,0,1.8,0,2.4 C-652-182.9-652-182.7-652.1-182.5C-652.1-182.7-652.1-182.6-652.1-182.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    transform: "translate(533.569 69.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    className: "st0",
    d: "M-674.9-182.5c0-0.1,0-0.2,0-0.2c0-0.2,0-0.4,0-0.7c0-0.6,0-1.4,0-2.5c0-2.2,0-5.2-0.1-8.9 l0.2,0.2l-22.8,0.1c-0.2,0.2,0.2-0.3,0.2-0.2v1.6c0,0.5,0,1.1,0,1.6c0,1.1,0,2.1,0,3.1c0,2.1,0,4,0,5.9l-0.2-0.2l16.3,0.1 l4.7,0.1h1.3C-675.2-182.5-675-182.5-674.9-182.5c-0.1,0-0.3,0-0.4,0h-1.2l-4.7,0.1l-16.5,0.1h-0.2v-0.2c0-1.9,0-3.9,0-5.9 c0-1,0-2.1,0-3.1c0-0.5,0-1.1,0-1.6v-1.6c0,0,0.4-0.4,0.2-0.2l22.8,0.1h0.2v0.2c0,3.8-0.1,6.8-0.1,9c0,1,0,1.8,0,2.4 C-674.8-182.9-674.8-182.7-674.9-182.5C-674.9-182.7-674.9-182.6-674.9-182.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    transform: "translate(43.542 126.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1123"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1762",
    x: -697.9,
    y: -195,
    className: "st1",
    width: 45.6,
    height: 12.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    transform: "translate(18.869 12.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    className: "st0",
    d: "M-652.1-182.5c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.6,0-1.4,0-2.4c0-2.1,0-5.2-0.1-9 l0.1,0.1l-45.6,0.1c0.1-0.1-0.2,0.2,0.2-0.2v3.1c0,1,0,2.1,0,3.1c0,2.1,0,4.1,0,6l-0.2-0.2l32.5,0.1l9.6,0.1h2.6h0.7 C-652.2-182.6-652.2-182.6-652.1-182.5c-0.1,0-0.1,0-0.2,0h-0.7h-2.5l-9.5,0.1l-32.6,0.1h-0.2v-0.2c0-2,0-4,0-6 c0-1,0-2.1,0-3.1v-3.1c0.4-0.4,0.1-0.1,0.2-0.2l45.6,0.1h0.1v0.1c0,3.9-0.1,7-0.1,9.1c0,1,0,1.8,0,2.4 C-652-182.9-652-182.7-652.1-182.5C-652.1-182.7-652.1-182.6-652.1-182.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    transform: "translate(392.433 223.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    x: -697.9,
    y: -195,
    className: "st1",
    width: 45.6,
    height: 12.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    transform: "translate(18.869 12.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    className: "st0",
    d: "M-652.1-182.5c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.6,0-1.4,0-2.4c0-2.1,0-5.2-0.1-9 l0.1,0.1l-45.6,0.1c0.1-0.1-0.2,0.2,0.2-0.2v3.1c0,1,0,2.1,0,3.1c0,2.1,0,4.1,0,6l-0.2-0.2l32.5,0.1l9.6,0.1h2.6h0.7 C-652.2-182.6-652.2-182.6-652.1-182.5c-0.1,0-0.1,0-0.2,0h-0.7h-2.5l-9.5,0.1l-32.6,0.1h-0.2v-0.2c0-2,0-4,0-6 c0-1,0-2.1,0-3.1v-3.1c0.4-0.4,0.1-0.1,0.2-0.2l45.6,0.1h0.1v0.1c0,3.9-0.1,7-0.1,9.1c0,1,0,1.8,0,2.4 C-652-182.9-652-182.7-652.1-182.5C-652.1-182.7-652.1-182.6-652.1-182.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    transform: "translate(149.063 65.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    className: "st0",
    d: "M-652.1-182.5c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.6,0-1.4,0-2.4c0-2.1,0-5.2-0.1-9 l0.1,0.1l-45.6,0.1c0.1-0.1-0.2,0.2,0.2-0.2v1.6c0,0.5,0,1,0,1.6c0,1,0,2.1,0,3.1c0,2,0,4.1,0,6l-0.2-0.2l32.5,0.1l9.6,0.1h2.6 h0.7C-652.2-182.6-652.2-182.6-652.1-182.5c-0.1,0-0.1,0-0.2,0h-0.7h-2.5l-9.5,0.1l-32.6,0.1h-0.2v-0.2c0-2,0-4,0-6v-6.2 c0.4-0.4,0.1-0.1,0.2-0.2l45.6,0.1h0.1v0.1c0,3.9-0.1,7-0.1,9.1c0,1,0,1.8,0,2.4C-652-182.9-652-182.7-652.1-182.5 C-652.1-182.7-652.1-182.6-652.1-182.5z"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M142.5,174.7H92.8v-19.6l47-73.4h22.4v75.2h17v17.8h-17v23.8h-19.8v-23.8H142.5z M142.5,109.7h-0.4l-29.2,47.2 h29.5L142.5,109.7L142.5,109.7z M233.7,79.7c13,0,42.2,5.1,42.2,60.4s-29.2,60.4-42.2,60.4s-42.2-5.1-42.2-60.4 C191.5,84.8,220.7,79.7,233.7,79.7z M233.7,181.6c19.8,0,22.4-27.1,22.4-41.6s-2.6-41.6-22.4-41.6s-22.4,27.1-22.4,41.6 C211.3,154.6,213.9,181.6,233.7,181.6z M319.2,128.7h5.1c11.4,0,22.8-1.7,22.8-15.8c0-8.9-6.9-15.3-16.7-15.3 c-7.9,0-14.7,4.8-17.5,12.9l-21-5.6c5.1-17.3,20.3-25.1,37.5-25.1c20.1,0,37.5,10.6,37.5,31.2c0,12.5-7.6,23.3-20,26.4v0.3 c14.8,2.1,22.8,14,22.8,28.4c0,22.3-18.6,34.5-39.4,34.5c-19.1,0-35-7.9-40.1-27.4l21.1-5.6c2.5,9.6,8.4,15.2,19,15.2 s19.6-7.4,19.6-18.3c0-15.2-13.9-17.8-25.9-17.8h-4.8V128.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 464.709, 189.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    transform: "translate(336.259 161.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    className: "st3",
    d: "M-590.6-337.6c0,0,7.7,1,8.8-5c2.8-15.8-15.8-22.5-15.8-22.5s-6.5-2-17.2-6.6 c-4.2-1.8-8.2-4.1-11.9-6.7c-3.4-2.5-7.9-2.4-11.2,0.1c-6,4.7-12.7,8.5-19.7,11.3c0,0-7.3,2.2-7.3,13.3c0,5.1,7.4,8.9,7.4,8.9 L-590.6-337.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    transform: "translate(345.91 185.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    className: "st4",
    d: "M-602.8-360.4l1.2-9.2c0,0-41.8-18.4-63.3-6.5v10.4L-602.8-360.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    transform: "translate(332.286 199.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    className: "st3",
    d: "M-664.9-373.4c0,0,5.3,5.1,16.9,5.8c21.2,1.3,55.6-7.5,55.6-7.5l-61.1-5.1L-664.9-373.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    transform: "translate(355.496 174.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    className: "st0",
    d: "M-645.2-376.4c0.5-0.3-0.3,11.4-0.3,11.4s-1.2,7.3-10.4,6.9c-9.8-0.5-9-9.7-9-9.7l0.5-8.6 c3.6,1.1,7.5-0.5,9.3-3.8C-655-380.2-650.7-373.3-645.2-376.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    transform: "translate(351.836 205.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    className: "st4",
    d: "M-609.3-380.1c-0.7,0.2-1.4,0.4-2.2,0.5l-5.9,1c-5,0.8-11.9,1.9-19.6,3 c-7.7,1.1-14.7,1.8-19.7,2.1c-2.5,0.2-4.6,0.2-6,0.3c-0.7,0.1-1.5,0-2.2-0.1c0.7-0.2,1.4-0.3,2.2-0.3l6-0.6 c5-0.5,12-1.3,19.6-2.4s14.6-2.1,19.6-2.7c2.5-0.3,4.6-0.5,6-0.7C-610.8-380.2-610-380.2-609.3-380.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    transform: "translate(1028.289 97.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(65.523 249.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    transform: "translate(25.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    className: "st5",
    d: "M-737.2-155.8c-2.6-3.1-3-8.1-2.6-12.2c0.4-4.1,1.3-8.2,0.7-12.2c-0.4-2.4-1.3-4.7-1.6-7.1 c-0.3-2.4,0.1-5.1,2-6.7c2.1-1.8,5.5-1.4,7.7,0.3s3.5,4.3,4.5,6.9c2.1,5.8,2.8,12.1,1.1,18s-5.7,11.1-11.5,12.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    transform: "translate(27.396 34.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    transform: "translate(14.17 1.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    className: "st6",
    d: "M-739.6-184.2c0.4-1.5,1.4-2.9,2.8-3.6c1.6-0.5,3.3-0.4,4.8,0.3s3,1.2,4.7,1.4 c1.6,0.1,3.5-0.7,3.9-2.2c0.5-1.5-0.4-3-1.5-4.1c-3.8-3.7-9.9-3.6-13.6,0.3c-1,1-1.7,2.2-2.2,3.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    transform: "translate(14.17 1.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    className: "st7",
    d: "M-739.6-184.2c0.4-1.5,1.4-2.9,2.8-3.6c1.6-0.5,3.3-0.4,4.8,0.3s3,1.2,4.7,1.4 c1.6,0.1,3.5-0.7,3.9-2.2c0.5-1.5-0.4-3-1.5-4.1c-3.8-3.7-9.9-3.6-13.6,0.3c-1,1-1.7,2.2-2.2,3.5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    transform: "translate(0.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    className: "st5",
    d: "M-738.9-176.4c-2.4-2.3-2.3-6.2-1.1-9.3c1.3-3,3.7-5.5,6.7-7c5.7-3,12.5-3.2,18.5-0.6 c-2.9,0.1-5.6,1.7-7.1,4.2c-1.3,2.2-1.6,4.8-2.7,7.1C-727.1-176.6-733.4-174.1-738.9-176.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    transform: "translate(0 2.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    className: "st8",
    d: "M-740.8-166.5c0-0.1,0-0.2,0-0.4s0-0.6,0-1c0-0.9,0.1-2.2,0.3-3.8c0.2-1.9,0.6-3.7,1-5.5 c0.5-2.2,1.4-4.4,2.5-6.4c2.1-3.7,5-6.8,8.5-9.1c0.7-0.5,1.3-0.8,1.9-1.1c0.6-0.3,1.1-0.5,1.5-0.7l1-0.4 c0.1-0.1,0.2-0.1,0.3-0.1c-0.1,0.1-0.2,0.1-0.3,0.2l-0.9,0.4c-0.4,0.2-0.9,0.5-1.4,0.8s-1.2,0.7-1.8,1.1 c-3.4,2.4-6.3,5.5-8.3,9.1c-2.4,4.2-3.1,8.7-3.6,11.8c-0.2,1.6-0.3,2.9-0.4,3.8c0,0.4,0,0.8-0.1,1 C-740.7-166.7-740.7-166.6-740.8-166.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    transform: "translate(0 27.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    transform: "translate(0 3.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    className: "st6",
    d: "M-736.3-195c-4.9,2.9-4.9,5.6-4.1,8.2c0.8,2.5,3.8,4.3,6.3,3.3c1.4-0.7,2.5-1.7,3.3-3 s1.8-2.4,2.9-3.4c1.2-1,2.9-1.1,4.2-0.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    transform: "translate(0 3.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    className: "st7",
    d: "M-736.3-195c-4.9,2.9-4.9,5.6-4.1,8.2c0.8,2.5,3.8,4.3,6.3,3.3c1.4-0.7,2.5-1.7,3.3-3 s1.8-2.4,2.9-3.4c1.2-1,2.9-1.1,4.2-0.3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    transform: "translate(0.805)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    className: "st5",
    d: "M-740.8-188.4c1.3-1.8,4.4-2.3,6.4-1.4c1.9,1,3.6,2.5,4.8,4.4c1.2,1.8,2.7,3.5,4.4,4.8 c1.8,1.2,4.3,1.7,6.1,0.4c1.2-0.9,1.9-2.2,2.1-3.6c0.2-1.4,0.1-2.9-0.3-4.3c-0.4-2-1.1-4.2-2.8-5.5c-1.8-1.5-4.4-1.5-6.7-1.4 c-2.7,0-5.3,0.4-7.9,1.2C-737.3-192.9-739.5-190.9-740.8-188.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    transform: "translate(10.591 0.541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    className: "st8",
    d: "M-728.2-158.2c0-0.1,0-0.3,0-0.4c0-0.3,0-0.7,0-1.2c0-1.1-0.1-2.6-0.1-4.5 c-0.1-1.9-0.1-4.1-0.3-6.6c-0.1-2.5-0.3-5.2-0.7-8.1c-0.2-1.4-0.4-2.7-0.8-4.1c-0.4-1.2-0.9-2.4-1.5-3.6 c-1-2-2.3-3.7-3.9-5.2c-1.1-1-2.3-1.8-3.6-2.5c-0.4-0.2-0.7-0.3-1.1-0.5c-0.1,0-0.3-0.1-0.4-0.2c0.1,0,0.3,0.1,0.4,0.1 c0.4,0.1,0.8,0.3,1.1,0.4c1.4,0.6,2.6,1.4,3.7,2.5c1.6,1.5,3,3.3,4,5.3c0.6,1.2,1.1,2.4,1.5,3.6c0.4,1.4,0.7,2.7,0.8,4.1 c0.4,2.9,0.6,5.6,0.7,8.1s0.2,4.7,0.2,6.6s0,3.4,0,4.5c0,0.5,0,0.9,0,1.2C-728.2-158.5-728.2-158.4-728.2-158.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    transform: "translate(24.388 9.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1159"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    className: "st8",
    d: "M-739.8-139.7c0,0,0-0.1-0.1-0.1l-0.1-0.4c-0.2-0.5-0.3-1.1-0.4-1.6c-0.4-2-0.5-4-0.4-6 c0.1-3,0.6-6,1.5-8.9c1-3.2,2.4-6.7,3.6-10.4c1.2-3.5,2-7.1,2.3-10.7c0.3-3,0.3-6,0.2-9c-0.1-2.6-0.2-4.6-0.3-6 c0-0.7-0.1-1.2-0.1-1.6c0-0.2,0-0.3,0-0.4v-0.1v0.1c0,0.1,0,0.3,0,0.4c0,0.4,0.1,0.9,0.1,1.6c0.1,1.4,0.3,3.5,0.4,6 c0.1,3,0.1,6-0.1,9c-0.3,3.7-1.1,7.3-2.3,10.8c-1.2,3.7-2.6,7.2-3.6,10.4c-0.9,2.9-1.4,5.8-1.5,8.8c-0.1,2,0,4,0.3,6 c0.1,0.7,0.2,1.2,0.3,1.6L-739.8-139.7C-739.8-139.8-739.8-139.7-739.8-139.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Sign",
    transform: "translate(75.817 115.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    transform: "translate(36.439 62.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    transform: "translate(0.146 0.146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    x: -740.8,
    y: -195,
    className: "st0",
    width: 5.1,
    height: 135.9
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1166"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_269",
    className: "st6",
    cx: -701.7,
    cy: -155.9,
    r: 29.6
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    transform: "translate(12.2 11.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    className: "st9",
    d: "M-687.2-168.2c0-0.1,0-0.3,0-0.4c0-0.3-0.1-0.7-0.1-1.3c0-0.3,0-0.6-0.1-0.9 c0-0.3-0.1-0.7-0.2-1.1c-0.1-0.9-0.3-1.8-0.6-2.7c-0.6-2.5-1.6-4.9-3-7.1c-6.5-10.9-19.9-15.6-31.8-11.3 c-1.2,0.4-2.3,0.9-3.4,1.5c-0.6,0.3-1.1,0.7-1.6,1c-0.6,0.3-1.1,0.7-1.6,1.1c-2.2,1.6-4,3.4-5.6,5.6 c-1.6,2.2-2.9,4.7-3.8,7.3c-1.8,5.4-1.8,11.3,0,16.7c0.9,2.6,2.1,5.1,3.8,7.3c0.8,1.1,1.7,2.1,2.6,3.1c0.9,0.9,1.9,1.8,3,2.6 c0.5,0.4,1,0.8,1.6,1.1s1.1,0.7,1.6,1c1.1,0.6,2.3,1.1,3.4,1.5c11.9,4.3,25.3-0.4,31.8-11.3c1.3-2.2,2.3-4.6,3-7.1 c0.3-0.9,0.4-1.8,0.6-2.7c0.1-0.4,0.1-0.8,0.2-1.1c0-0.3,0-0.7,0.1-0.9c0-0.5,0.1-1,0.1-1.3 C-687.2-167.9-687.2-168-687.2-168.2c0,0.1,0,0.3,0,0.4c0,0.3,0,0.7,0,1.3c0,0.3,0,0.6,0,0.9c0,0.3-0.1,0.7-0.1,1.1 c-0.1,0.9-0.3,1.9-0.5,2.8c-0.6,2.5-1.6,4.9-2.9,7.2c-3.9,6.6-10.5,11.3-18.1,12.7c-4.7,0.9-9.6,0.5-14.1-1.1 c-1.2-0.4-2.4-0.9-3.5-1.5c-0.6-0.3-1.1-0.7-1.7-1c-0.6-0.3-1.1-0.7-1.6-1.1c-2.2-1.6-4.1-3.5-5.7-5.7 c-1.7-2.2-3-4.8-3.9-7.4c-1.9-5.5-1.9-11.5,0-17c0.9-2.7,2.2-5.2,3.9-7.4c1.6-2.2,3.5-4.1,5.7-5.7c0.5-0.4,1.1-0.8,1.6-1.1 c0.6-0.3,1.1-0.7,1.7-1c1.1-0.6,2.3-1.1,3.5-1.5c4.5-1.6,9.4-2,14.1-1.1c7.6,1.4,14.1,6.1,18.1,12.7c1.3,2.2,2.3,4.6,2.9,7.2 c0.2,0.9,0.4,1.8,0.5,2.8c0.1,0.4,0.1,0.8,0.1,1.1v0.9c0,0.5,0,1,0,1.3C-687.2-168.5-687.2-168.3-687.2-168.2z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    transform: "translate(629.395 140.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    className: "st9",
    d: "M-213.1-87.3c-0.6-0.9-1.9-1.2-2.8-0.6c-0.2,0.1-0.3,0.2-0.4,0.4c-0.4,0.6-0.7,1.3-0.9,2 c-0.6,1.8-1.1,3.5-1.6,5.3c-0.1,0.2-0.3,0.3-0.4,0.5c-0.1-0.2-0.3-0.4-0.3-0.5c-0.1-1-0.2-2-0.3-3c-0.2-2-0.3-4-0.5-5.9 c-0.3-3.3-0.6-6.6-0.9-10c0-0.4-0.2-0.7-0.4-1c-0.6-0.6-1.5-0.8-2.2-0.4c-0.7,0.3-1.1,1.1-1,1.9c0.3,3.5,0.6,7,1,10.6 c0,0.2,0,0.3,0,0.5c0,0.1-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.4-0.3c-0.1-0.2-0.1-0.3-0.1-0.5c-0.4-4.1-0.8-8.2-1.1-12.3 c0-0.3,0-0.5-0.1-0.8c-0.1-0.7-0.6-1.2-1.3-1.2c-1-0.3-2.1,0.3-2.3,1.3c-0.1,0.3-0.1,0.6,0,0.9c0.4,4,0.7,8.1,1.1,12.1 c0,0.2,0,0.5,0,0.7c0,0.1-0.1,0.3-0.3,0.3s-0.3-0.1-0.4-0.2c-0.1-0.2-0.1-0.4-0.1-0.6c-0.3-3.2-0.6-6.5-0.9-9.7 c-0.1-1-1.1-1.7-2.1-1.6s-1.7,1-1.6,1.9c0.3,3.4,0.6,6.9,1,10.3c0,0.2,0.1,0.4,0,0.6s-0.2,0.4-0.3,0.5c-0.1-0.2-0.4-0.3-0.4-0.5 c-0.1-1.2-0.2-2.5-0.3-3.7c-0.1-1.3-0.2-2.6-0.4-4c-0.1-1-1-1.6-1.9-1.5h-0.1c-0.9,0.1-1.6,0.8-1.5,1.7v0.1 c0.2,2.6,0.3,5.2,0.5,7.8l0,0c0.1,1.6,0.3,3.2,0.4,4.7c0.1,3.2,0.8,6.3,2.1,9.1c1.1,2.6,3.5,4.5,6.4,5c3.1,0.6,6.3-0.1,9-1.8 c1.9-1.1,3.2-2.8,3.8-4.9c1-4,2-8,3-12C-212.8-86.3-212.9-86.8-213.1-87.3z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg403, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/403.513e572c.svg";
export { ForwardRef as ReactComponent };